import React from "react";
import ContactSales from "../ContactSales";

const faq = [
  {
    id: 0,
    q: "What is Cashfree Payouts?",
    a:
      "Cashfree Payouts is a payment disbursal platform used by businesses to do bulk payouts. When you create a Payouts account, Cashfree creates a virtual wallet for you. You can add funds from your bank accounts to the wallet and use the funds to do payouts. You can use Payouts dashboard to do single or bulk payouts via excel upload or integrate Payouts APIs with your product or ERP to automate bulk payouts. ",
  },
  {
    id: 1,
    q: "What can I use Cashfree Payouts for?",
    a: (
      <>
        <p>
          You can use Cashfree Payouts for a wide range of business use cases.
          Here is how some of the leading businesses in India are using Payouts:
        </p>
        <ul>
          <li>
            Hyperlocal services like Grab and Dunzo use it for on-demand wage
            payouts.
          </li>
          <li>
            E-commerce platforms like Nykaa and Xiaomi use Payouts APIs for
            instant refunds processing.
          </li>
          <li>
            Loan providers like IndiaLends and Cashbean use it for instant loan
            disbursals.
          </li>
          <li>
            Gaming websites like Dream11 and RummyCircle use Payouts for
            real-time player&apos;s winning cashouts.
          </li>
          <li>
            Marketplace platforms like Milaap and Tata Sky have integrated
            Payouts with their products for automated vendor payouts.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    q: "How is Payouts different from using banks for bulk payouts?",
    a: (
      <>
        <p>
          Bulk payouts via bank accounts happen by manually adding every
          beneficiary before transferring or by uploading a spfsheet on the
          banking portal. Cashfree automates bulk payouts fully via APIs and
          offers a much simpler alternative.
        </p>
        <p>
          Unlike banks, where a single error in a payout file can block all the
          bulk payouts, using Cashfree, even if there are invalid records in a
          file, valid transfers go through. Reconciliation for failed and
          invalid transfers is automated so you always know which transfer
          failed out of hundreds of payouts, and why. At Cashfree, new
          beneficiary addition and activation is instant.
        </p>
        <p>
          Cashfree also allows you to send money to any Paytm Wallet, Amazon Pay
          Wallet, UPI ID or native wallets in addition to bank accounts, even on
          holidays. Lastly, all of this can be automated and built into your
          product or internal systems using our powerful Payouts APIs.
        </p>
      </>
    ),
  },
  {
    id: 3,
    q: "How can I get started? What documents are needed?",
    a: (
      <>
        <p>
          For faster Payouts account activation,{" "}
          <a
            className="link"
            href="https://merchant.cashfree.com/merchants/signup"
            target="_blank"
            rel="noopener noreferrer">
            signup
          </a>{" "}
          here. Once logged in, click on activate Payouts and add your business
          details and upload copies of your business documents. Follow the steps
          to{" "}
          <a
            className="link"
            href="https://dev.cashfree.com/get-started#account-activation"
            target="_blank"
            rel="noopener noreferrer">
            complete your account activation.
          </a>
        </p>

        <p>
          In case of any queries or if you are looking for a customized
          solution, get in touch with our sales team{" "}
          <ContactSales
            className="link remove-btn-style"
            href="/contact-sales?source-action=Payout%20Page"
            target="_blank"
            rel="noopener noreferrer">
            here.
          </ContactSales>{" "}
          Our team will connect with you in 24 working hours. Meanwhile, you can
          also explore the product in test environment and use test API
          credentials to try out the integration before going live. View{" "}
          <a
            className="link"
            href="https://dev.cashfree.com/payouts/"
            target="_blank"
            rel="noopener noreferrer">
            developer documentation here.
          </a>
        </p>
      </>
    ),
  },
  {
    id: 4,
    q: "Do I need to be a registered business?",
    a:
      "Yes, Payouts can be used only by registered businesses. If you are not yet registered as a business but plan to start soon, you can signup and explore the product in test environment. We can also set up an account with limits on payout volume after understanding your business and future needs.",
  },
  {
    id: 5,
    q: "Do you support payouts to all banks and bank accounts?",
    a:
      "Yes, you can make payouts to any active savings or current bank account in India. However, NRE and NRO bank accounts are not supported.",
  },
  {
    id: 6,
    q: "Do you support payouts to and from other countries?",
    a: (
      <>
        <p>
          Yes, it is possible to send bulk payouts to beneficiaries in India
          from another country using{" "}
          <a
            className="link"
            href="/send-money-to-india/global-payouts/"
            target="_blank"
            rel="noopener noreferrer">
            Global Payouts.
          </a>{" "}
          The funds can be added by the businesses in USD, EUR and other freely
          convertible currencies. The purpose of the payment must be known while
          setting up the account.
        </p>
        <p>
          An Indian business can also send a payout to other countries. However,
          there are restrictions around the volume of payments and the purpose
          of payments. Get in touch with us to learn more.
        </p>
      </>
    ),
  },
  {
    id: 7,
    q: " Can I transfer funds on Sundays and bank holidays?",
    a: (
      <>
        <p>
          Yes, it is possible to make payouts even on Sundays and bank holidays.
        </p>
      </>
    ),
  },
  {
    id: 8,
    q: "How long does it take to transfer funds?",
    a: (
      <>
        <p>
          Transfers to bank accounts happen instantly. Transfers for amounts in
          excess of ₹2,00,000 are restricted by banking hours and can take
          longer. Payouts to other modes like Paytm, AmazonPay wallet, cards,
          UPI ID happen instantly.
        </p>
      </>
    ),
  },
  {
    id: 9,
    q: "What happens in case the account details are incorrect?",
    a: (
      <>
        <p>
          Transfers to incorrect account details fail instantly. For certain
          banks, it may take up to 24 hours to receive a confirmation of
          failure. To ensure that account details are correct, you can activate
          <a
            className="link"
            href="/bank-account-verification/"
            target="_blank"
            rel="noopener noreferrer">
            Cashfree Bank Account Verification
          </a>{" "}
          and verify the beneficiary account validity and beneficiary name at
          the bank.
        </p>
      </>
    ),
  },
  {
    id: 10,
    q: "Is it simpler to send bulk payouts file uploads or via APIs?",
    a: (
      <>
        <p>
          Using bulk file uploads or manual transfers requires no technical
          expertise and is the quickest way to get started. However, if you want
          to automate the payouts from your product or ERP, APIs should be used.
          Integrating the API can take a day or two depending on the complexity
          of integration. Many businesses start by using the bulk file upload or
          manual transfer option, and gradually automate operations by
          integrating the API. View{" "}
          <a
            className="link"
            href="https://dev.cashfree.com/payouts-api/"
            target="_blank"
            rel="noopener noreferrer">
            developer documentation here.
          </a>
        </p>
      </>
    ),
  },
];
export default faq;
